import { render, staticRenderFns } from "./TableCommitRemind.vue?vue&type=template&id=163e8359"
import script from "./TableCommitRemind.vue?vue&type=script&lang=js"
export * from "./TableCommitRemind.vue?vue&type=script&lang=js"
import style0 from "./TableCommitRemind.vue?vue&type=style&index=0&id=163e8359&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports